import {capacityConstants} from '../../constants/capacity.constants';

export const setCapacityTree = (capacityTree) => ({
    type: capacityConstants.GET_CAPACITY_TREE,
    capacityTree: capacityTree
});
